import agent from 'api/agent';

export const Roles = {
    GetAll: () => agent.requests.get('/Role/all'),
};
